<template>
  <section class="form-list">
    <el-form
      class="form"
      ref="form"
      :rules="rules"
      :model="post"
      label-position="right"
      label-width="130px"
    >
      <el-form-item label="所属学员">
        <v-avatar-nickname
          :value="student.selfie"
          :nickname="student.student_name"
          :link-page-name="RouteConfig.studentDetail.name"
          :link-page-id="post.student_id"
          :avatar-size="50"
        />
      </el-form-item>

      <el-form-item label="课次券类型">{{ post.card_ticket_type_name }}</el-form-item>
      <el-form-item label="有效次数"><span class="success-color">{{ post.expire_number }}</span> 次</el-form-item>
      <el-form-item label="失效日期" prop="expire_time">
        <span class="success-color">{{ post.expire_time | timeToYmdHis }}</span>
      </el-form-item>

      <el-form-item label="收款方式">
        <span v-if="post.actual_payment > 0">{{ findPaymentModeName(post.card_payment_mode_id) }}</span>
        <span v-else>
          <span v-if="post.card_id" class="success-color">办卡附赠</span>
          <span v-else class="success-color">免费赠送</span>
        </span>
      </el-form-item>
      <el-form-item v-if="post.card_payment_mode_id === paymentModes.youZan.value" label="有赞核销金额">
        {{ post.you_zan_payment | toYuan }} 元
      </el-form-item>
      <el-form-item label="课次券售价">
        <span>{{ post.price | toYuan }}</span> 元
      </el-form-item>
      <el-form-item label="实际付款">
        <span class="danger-color">{{ post.actual_payment | toYuan }}</span> 元
        <el-alert
          v-if="post.integral > 0"
          :title="`积分抵扣 ${post.integral} 元`"
          type="warning"
          show-icon
          :closable="false"
        />
      </el-form-item>
      <el-form-item label="付款凭证">
        <v-img v-if="post.receipt" :value="post.receipt" class="cover"/>
        <span v-else class="info-color">未上传</span>
      </el-form-item>
      <el-form-item label="付款备注">
        <span v-if="post.payment_remark" class="success-color">{{ post.payment_remark }}</span>
        <span v-else class="info-color">未填写</span>
      </el-form-item>
      <el-form-item label="付款备注图片">
        <v-img v-if="post.remark_file" :value="post.remark_file" class="cover"/>
        <span v-else class="info-color">未上传</span>
      </el-form-item>
      <el-form-item label="未消费金额">
        <span class="danger-color">{{ post.not_consumed_amount | toYuan }}</span> 元
      </el-form-item>

      <el-form-item label="退款金额" prop="del_payment">
        <v-input-money
          class="w100"
          v-model="post.del_payment"
          :is-show-suffix="true"
          placeholder="请输入给学员退卡的所付的金额"
        />
      </el-form-item>

      <el-form-item label="退卡原因">
        <el-radio v-model="post.is_input_error" :label="0">非录入错误</el-radio>
        <el-radio v-model="post.is_input_error" :label="1">录入错误</el-radio>
        <el-input
          type="textarea"
          :autosize="{ minRows: 4 }"
          placeholder="请输入 2 个字符以上的退卡原因"
          v-model="post.reason"
          maxlength="250"
          show-word-limit
        />
      </el-form-item>

      <v-image-upload
        v-model="post.reason_img"
        label="退卡原因截图"
        prefix="card-ticket"
        ratio="9:20"
      />

      <el-form-item>
        <el-button type="primary" @click="handleSubmit" :loading="isSaving">确认退券</el-button>
        <el-button @click="RouteConfig.cardTicketList.back">取消</el-button>
      </el-form-item>

    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { pickerOptionsBetweenSystemStartAndToday, pickerOptionsOfAfterToday, pickerOptionsOfAfterSystemStartDay } from '@/utils/formats';
import { paymentModes } from "@/enums/paymentModes";
import { show, destroy } from '@/api/card-ticket';
import { toCent, toSecond, toYuan } from '@/filters';
import { findPaymentModeName } from "@/enums/paymentModes";

export default {
  name: RouteConfig.cardTicketDelete.name,
  data: () => ({
    RouteConfig,
    paymentModes,
    pickerOptionsOfAfterSystemStartDay,
    pickerOptionsBetweenSystemStartAndToday,
    pickerOptionsOfAfterToday,
    isSaving: false,
    cardNumber: '',
    integral: 0,
    student: {
      id: 0,
      selfie: '',
      student_name: '',
      is_new: 0,
      is_not_new_reason: '',
      integral: 0,
    },
    cardTicketType: {
      id: 0,
      update_time: 0,
      card_ticket_type_name: '',
      expire_number: 0,
      expire_days: 0,
      price: 0,
      is_new: 0,
    },
    post: {
      is_input_error: 0,
      student_id: 0,
      card_ticket_type_id: 0,
      update_time: 0,
      expire_number: '',
      expire_days: '',
      expire_time: '',
      card_payment_mode_name: '',
      you_zan_number: '',
      actual_payment: '',
      not_consumed_amount: '',
      you_zan_payment: '',
      payment_remark: '',
      receipt: '',
      remark_file: '',
      integral: '',
      card_ticket_type_name: '',
      price: 0,
      price_original: 0,
      reason: '',
      reason_img: '',
      del_payment: '',
    },
    rules: {
      reason: [{ required: true, message: '请输入退券的原因', trigger: 'change' }],
    },
  }),
  computed: {
    ...mapGetters([
      'isAdministrator',
    ]),
    id() {
      return +this.$route.params.id || 0;
    },
  },
  watch: {
    'post.is_input_error'(value) {
      let { post } = this;
      if (value) {
        if (!post.reason) post.reason = '录入错误';
      } else {
        if (post.reason === '录入错误') post.reason = '';
      }
    },
  },
  beforeMount() {
    this.show();
  },
  methods: {
    findPaymentModeName,
    toYuan,
    async show() {
      const { isError, data } = await show(this.id);
      if (isError) return;

      const { post } = this;
      const updateData = {};
      Object.keys(post).forEach(key => {
        if (key in data) updateData[key] = data[key];
      });

      updateData.expire_number = toYuan(updateData.expire_number);
      updateData.expire_days = toYuan(updateData.expire_days);
      updateData.del_payment = toYuan(data.not_consumed_amount);

      Object.assign(post, updateData);

      this.student = {
        id: data.student_id || 0,
        selfie: data.student.selfie || '',
        student_name: data.student.student_name || '',
      };
    },
    handleSubmit() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        this.isSaving = true;
        const post = { ...this.post };
        const updateData = {
          update_time: post.update_time,
          expire_time: toSecond(post.expire_time),
          reason: post.reason,
          reason_img: post.reason_img,
          del_payment: toCent(post.del_payment),
          is_input_error: post.is_input_error,
        };

        this.isSaving = false;
        const { isError } = await destroy(this.id, updateData);
        this.isSaving = false;
        if (!isError) RouteConfig.cardTicketDeletedList.push();
      });
    },
  },
};
</script>
